<template>
<v-container>
  <v-dialog v-model="registrationUpdateDialog" max-width="800px" eager>
    <RegisterForm ref="RegisterForm"
      @registration-updated="refresh(); registrationUpdateDialog = false;"
      @dialog-closed="registrationUpdateDialog = false">
    </RegisterForm>
  </v-dialog>

  <v-data-table class="d-print-only" ref="PrintArea" show-select
    v-model="selectedRegistrations"
    :headers="headers"
    :items="registrations"
    :loading="loading"
    :search="searchTerm"
    :custom-filter="filters.registrationFilter"
    :footer-props="footerProps"
    :items-per-page="itemsPerPage">
    <template v-slot:top>
      <v-container class="d-print-none">
        <div class="d-flex">
          <h2>Registrations</h2>
          <v-spacer></v-spacer>
          <v-btn color="primary" small dark
            @click="refresh()">
            <v-icon left small>mdi-refresh</v-icon>
            Refresh
          </v-btn>
          <v-btn class="mx-2" color="primary" small :dark="!(selectedRegistrations.length == 0)"
            :disabled="(selectedRegistrations.length == 0)"
            @click="downloadSidCsv(selectedRegistrations)">
            <v-icon left small>mdi-content-copy</v-icon>
            SID ({{ selectedRegistrations.length }})
          </v-btn>
          <v-btn color="primary" small :dark="!(selectedRegistrations.length == 0)"
            :disabled="(selectedRegistrations.length == 0)"
            @click="downloadCredentialsCsv(selectedRegistrations)">
            <v-icon left small>mdi-download</v-icon>
            LMS ({{ selectedRegistrations.length }})
          </v-btn>
        </div>
        <v-row justify="center">
          <v-col cols="12" md="4">
            <v-text-field
              label="Search"
              prepend-icon="mdi-magnify"
              v-model="searchTerm"
              autocomplete="off"/>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-slot:item._index="{ item }" >
      {{ registrations.indexOf(item) + 1 }}
    </template>

    <template v-slot:item.firstname="{ item }">
      {{ item.firstname }} {{ item.extname }}
    </template>

    <template v-slot:item._address="{ item }">
      {{ item.city }}, {{ item.barangay }}
    </template>

    <template v-slot:item._course="{ item }">
      {{ item['course.shortTitle'] || item['course.title'] }}
    </template>

    <template v-slot:item._enrollmentStatus="{ item }">
      {{ printEnrollmentStatus(item) }}
    </template>


    <template v-slot:item._actions="{ item }">
      <v-btn-toggle>
        <v-btn small
        :disabled="(item.rejecterId > 0)"
        @click="updateRegistration(item)">
          <v-icon left small>mdi-pencil</v-icon>
          Edit
        </v-btn>
        <v-btn small
          @click="downloadSidCsv([item])">
          <v-icon left small>mdi-content-copy</v-icon>
          Copy
        </v-btn>
      </v-btn-toggle>
    </template>

			<!-- 
				<template v-slot:no-data>
					No Data Found
				</template> 
			-->
  </v-data-table>
</v-container>
</template>

<script>
import Moment from 'moment'
import Api from '../../services/api'
import Report from '../../services/report'
import DataTableMixin from '../../mixins/data-table.mixin'
import CourseMixin from '../../mixins/course.mixin'
import RegisterForm from '../register/RegisterForm'
import Clipboard from '../../services/clipboard';
import Notify from '../../services/notify'
import RegistrationService from './services/registration.service';


export default {
  name: 'RegistrationSids',
  components: { RegisterForm },
  mixins: [ CourseMixin, DataTableMixin ],
  data() {
    return {
      selectedRegistrations: [],
      registrations: [],
      loading: false,
      searchTerm: '',
      headers: [
        { text: 'Reg.ID', value: 'id' },
        { text: 'Lastname', value: 'lastname', align: 'start' },
        { text: 'Firstname', value: 'firstname' },
        { text: 'Middlename', value: 'middlename' },
        { text: 'Address', value: '_address' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Course', value: '_course'},
        { text: 'Status', value: '_enrollmentStatus' },
        { text: 'Actions', value: '_actions', sortable: false },
      ],
      users: [],
      dateMenu: false,
      date: [],
      registrationUpdateDialog: false,
      lmsCredentialFlag: false,
    }
  },
  mounted() {
    this.date = [
      Moment().subtract(1, 'year').format('YYYY-MM-DD'),
			// Moment().startOf('year').format('YYYY-MM-DD'),
			Moment().startOf('endOf').format('YYYY-MM-DD'),
		];
    this.refresh();
  },
  methods: {
    downloadCredentialsCsv() {
      if(this.lmsCredentialFlag) {
        let csvData = RegistrationService.generateCredentials(this.selectedRegistrations);
        Report.toCSV(csvData, 'registrations.csv');
      } else {
        Notify.prompt('Enter password', 'Enter password generate data')
          .then((password) => {
            if(password == 'fdsa') {
              this.lmsCredentialFlag = true;
              this.downloadCredentialsCsv();
            } else {
              Notify.error.invalidPassword();
              this.dialog = false;
            }
          });
      }
    },

    downloadSidCsv(registrations) {
      let data = registrations.map(
        element => ({
          sid: element.id,
          lastname: element.lastname,
          firstname: element.firstname,
          middlename: element.middlename,
          extname: element.extname,
          course: element['course.title'],
          mobile: element.mobile,
          address: (
              ((element.street)? element.street + ', ' : '') +
              element.barangay + ', ' +
              element.city
            ).toUpperCase(),
          bloodtype: element.bloodtype,
          birthdate: element.birthdate,
          sex: element.sex,
          emergencyPerson: element.emergencyPerson,
          emergencyNumber: element.emergencyNumber,
          emergencyAddress: element.emergencyAddress,
        })
      );

      Clipboard.copyTextToClipboard(JSON.stringify(data));
      Notify.toast('Copied to clipboard!');
      // Report.toCSV(data, 'sid_data.csv');
    },

    refresh() {
      this.getRegistrations();
    },

    getRegistrations() {
      if(this.date.length < 2) {
        return;
      }

      this.loading = true;
      Api.registration.getAll(
        this.date[0],
        this.date[1],
        null,
        null,
        this.selectedCourse,
        this.status,
      )
        .then((response) => {
          this.registrations = response.data;
        })
        .catch(() => {
          this.registrations = [];
        })
        .finally(() => {
          this.loading = false;
          this.itemsPerPage = (this.selectedCourse)? -1 : 15;
        });
    },

    updateRegistration(item) {
      this.registrationUpdateDialog = true;
      this.$refs.RegisterForm.updateRegistration(item.id);
    },

    getUserName(userId) {
      for(let i=0; i<this.users.length; i++) {
        if(this.users[i].id == userId) {
          let user = this.users[i];
          return user.firstname[0] + '. ' + user.lastname;
        }
      }

      return 'N/A';
    },
    
    printEnrollmentStatus(item) {
      if(!item) {
        return 'UNPROCESSED';
      }
      else if(item.enrollerId) {
        return 'ENROLLED';
      }
      else if(item.rejecterId) {
        return 'REJECTED';
      }
      else if(item.approverId) {
        return 'APPROVED';
      }
      return 'UNPROCESSED';
    }
  }
}
</script>